import {useTranslation} from '@aboutyou/i18n';
import {useContactRoute, useHistory} from '@aboutyou/router';
import {useTrackFeature, useTrackOriginClick} from '@aboutyou/tracking';
import {Heading20, mobileOnly} from '@aboutyou/ui-components';
import React, {useState} from 'react';
import styled, {css} from 'styled-components';
import {FeedbackModal} from './FeedbackModal';
import {VoteButton} from './VoteButton';

export const ArticleFeedback = () => {
  const {t} = useTranslation();
  const {push} = useHistory();
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const contact = useContactRoute();
  const trackFeature = useTrackFeature();

  const trackOriginClick = useTrackOriginClick()('selfservice_contact_us');

  return (
    <Container>
      <TitleWithMargin>{t('Was this answer helpful?')}</TitleWithMargin>
      <VoteButtons data-testid="ArticleFeedbackVoteButtons">
        <VoteButton
          onClick={() => {
            setIsFeedbackModalOpen(true);
            trackFeature({
              eventType: 'submit',
              label: 'self_service_flow_positive_feedback',
            });
          }}
          vote="up"
        >
          {t('Yes, my question was answered')}
        </VoteButton>
        <VoteButton
          onClick={() => {
            push(contact);
            trackFeature({
              eventType: 'submit',
              label: 'self_service_flow_negative_feedback',
            });
            trackOriginClick();
          }}
          vote="down"
        >
          {t('No, I still need help. Click here to contact us')}
        </VoteButton>
      </VoteButtons>
      <FeedbackModal
        isOpen={isFeedbackModalOpen}
        onClickClose={() => setIsFeedbackModalOpen(false)}
      />
    </Container>
  );
};

const Container = styled.div`
  margin-top: 60px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const TitleWithMargin = styled(Heading20)`
  margin-bottom: 40px;
`;

const VoteButtons = styled.div`
  max-width: 650px;
  display: flex;
  gap: 20px;

  ${mobileOnly(
    css`
      justify-content: stretch;
      flex-direction: column;
    `,
  )}
`;
